import { Phone, MessageCircle, MapPin, Mail } from "lucide-react";
import CallbackForm from "@/components/CallbackForm";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { WHATSAPP_URL, PHONE_NUMBER, ADDRESS } from "@/lib/pdf";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="bg-navy py-16 text-white sm:py-20">
        <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
          <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
            Contact WillSeva
          </div>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl">
            We'd love to hear from you.
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-white/75 sm:text-base">
            Our team will call you back within 24 hours.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="grid gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          {/* Form */}
          <Card className="border-[#0A1128]/10 shadow-sm">
            <CardContent className="p-8 sm:p-10">
              <h2 className="font-serif text-2xl text-navy">Request a Callback</h2>
              <p className="mt-2 text-sm text-[#4A5568]">
                Fill this and we'll ring you back. Prefer a quicker reply? WhatsApp us.
              </p>
              <div className="mt-6">
                <CallbackForm testPrefix="contact-callback" />
              </div>
            </CardContent>
          </Card>

          {/* Contact info */}
          <div className="space-y-5">
            <Card className="border-[#0A1128]/10 shadow-sm">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">
                  <div className="flex h-11 w-11 items-center justify-center rounded-md bg-navy text-gold">
                    <MessageCircle size={18} />
                  </div>
                  <div className="flex-1">
                    <div className="font-serif text-lg text-navy">WhatsApp</div>
                    <p className="mt-1 text-sm text-[#4A5568]">
                      Fastest way to reach us. English, Hindi, Marathi supported.
                    </p>
                    <a
                      href={WHATSAPP_URL}
                      target="_blank"
                      rel="noreferrer"
                      className="mt-3 inline-flex"
                    >
                      <Button
                        className="bg-[#25D366] text-white hover:bg-[#1FBE5A]"
                        data-testid="contact-whatsapp-btn"
                      >
                        Message on WhatsApp
                      </Button>
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-[#0A1128]/10 shadow-sm">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">
                  <div className="flex h-11 w-11 items-center justify-center rounded-md bg-navy text-gold">
                    <Phone size={18} />
                  </div>
                  <div>
                    <div className="font-serif text-lg text-navy">Tap to Call</div>
                    <p className="mt-1 text-sm text-[#4A5568]">
                      <a
                        href="tel:+919167249612"
                        className="font-medium text-navy underline-offset-4 hover:underline"
                        data-testid="contact-phone-link"
                      >
                        {PHONE_NUMBER}
                      </a>
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-[#0A1128]/10 shadow-sm">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">
                  <div className="flex h-11 w-11 items-center justify-center rounded-md bg-navy text-gold">
                    <MapPin size={18} />
                  </div>
                  <div>
                    <div className="font-serif text-lg text-navy">Visit Us</div>
                    <p className="mt-1 text-sm text-[#4A5568]" data-testid="contact-address">
                      {ADDRESS}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Map */}
        <div className="mt-12 overflow-hidden rounded-xl border border-[#0A1128]/10 shadow-sm" data-testid="contact-map">
          <iframe
            title="WillSeva Office Location"
            src="https://www.google.com/maps?q=Tardeo+AC+Market,+Mumbai+400034&output=embed"
            width="100%"
            height="420"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>
    </div>
  );
}
